import { Stats, PatternItem } from "./Stats";
import React from "react";


export const SizeStats = ({dataList, gameName}) => {
    console.log("Rendering SizeStats")
    const patternFunc = (results) => {
        return results.map((result, index) => result > 45 ? <PatternItem key={index} color="#00ff5a">B</PatternItem>: <PatternItem key={index} color="#ff9900">S</PatternItem>)
    }

    const ratioFunc = (results) => {
        const below45 = results.filter((result) => result < 45).length
        return `${below45} : ${results.length - below45}`
    }

    return (
        <Stats
            dataList={dataList}
            patternFunc={patternFunc}
            ratioFunc={ratioFunc}
            gameName={gameName}
        />
    )
}







